export default {
  id: 'pnp-customer-tax-exempt',
  name: 'PNP - Tax Exempt',
  components: {
    ExpiredTIN: 'ExpiredTIN',
  },
};
